import { JoiAccount, isAccountAdmin, isAccountManager } from "./accounts.data";
import { JoiApp, JoiAppInfo } from "./app.data";
import { JoiEvent } from "./events.data";
import { Informable } from "./informables.data";
import { NewOnsiteData, OldOnsiteData } from "./onsite.data";
import { Program } from "./programs.data";
import { Budget } from "./budget.data";
import { ShareableItem } from "./share.data";
import { Task } from "./tasks.data";
import { User } from "./user.data";


export type EventBackupType = 'User' | 'Scheduled' | 'OnLoadBackup'
export const MAX_USER_BACKUPS = 5
export const MAX_AUTO_BACKUPS = 14
export const MAX_BACKUP_BACKUPS = 1


export interface EventBackupBase {
  id: string // backupId
  eventId: string
  accountId: string
  name: string // backup name
  creator: string // static reference to creator, empty for scheduled / automatic backups
  date: number // utc time
  type: EventBackupType
}

export interface EventBackupsList {
  backups: EventBackupBase[]
}

export interface EventBackup extends EventBackupBase {
  event: JoiEvent
  onsiteData: NewOnsiteData | OldOnsiteData
  tasks: Task[]
  programs: Program[]
  shareables: ShareableItem[]
  informables: Informable[]
  budget: Budget
  apps: JoiApp[]
  appInfos: JoiAppInfo[]
  publicAppInfos: JoiAppInfo[]
}

export const canDoBackups = (event: JoiEvent, account: Partial<JoiAccount>, user: User) => {
  const isAdmin = isAccountAdmin(account, user.uid)
  const adminOnEventAndWorkforce = isAdmin && !!event?.workforce.find(w => w.uid === user.uid)
  const isEventOwner = event.owner_uid === user.uid
  // console.log({ isManager, adminOnEventAndWorkforce, isEventOwner, event, account, user })
  return adminOnEventAndWorkforce || isEventOwner
}


